import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AccountingAnalyticCategoryDashboardPage" */
	'pages/Invoice/AccountingAnalyticCategory/AccountingAnalyticCategoryDashboardPage'));

export default [{ component, exact: true, path: '/accounting_analytic_categories/:accountingAnalyticCategoryId' }];